import { reviews } from "@/mocks/manga";

export default function ReviewSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-12">
          <span className="inline-block bg-accent-100 text-accent-700 text-xs font-medium px-3 py-1 rounded-full mb-4">
            漫友评价
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 leading-tight">
            听听蛙友们
            <br />
            怎么说
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {reviews.map((review, index) => (
            <article
              key={review.id}
              className={`bg-background-50 rounded-lg p-5 md:p-6 border border-background-200/70 ${
                index % 3 === 1 ? "md:mt-6" : index % 3 === 2 ? "md:mt-12" : ""
              }`}
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={review.avatarUrl}
                    alt={review.username}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-foreground-950">{review.username}</h4>
                  <p className="text-xs text-foreground-500">{review.handle}</p>
                </div>
              </div>
              <div className="relative">
                <i className="ri-double-quotes-l text-2xl text-accent-300 absolute -top-1 -left-1"></i>
                <p className="text-sm text-foreground-700 leading-relaxed pl-5">
                  {review.content}
                </p>
              </div>
              <div className="mt-4 pt-3 border-t border-background-100">
                <span className="text-xs text-accent-600 font-medium">
                  正在追：《{review.manga}》
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}